import React, { useEffect } from "react";

import { motion } from "framer-motion";

export const SyaratKetentuan = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-cyan-600 flex-col justify-center relative bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-base sm:text-lg md:text-xl font-normal uppercase mb-1 md:mb-2 text-cyan-600"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          PT VISI EKOSISTEM DIGITAL
        </motion.h2>

        <motion.p
          className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black mx-auto mb-8 md:mb-16 text-cyan-600 px-4"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3, ease: "easeInOut" }}
          viewport={{ once: true }}
        >
          SYARAT & KETENTUAN
        </motion.p>

        <div className="max-w-6xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <h3 className="text-xl font-bold text-cyan-900 mb-4">
                Syarat & Ketentuan Penggunaan
              </h3>
              <div className="text-lg text-cyan-800 space-y-6">
                <p>Selamat datang di VionixAsia!</p>

                <p>
                  Syarat dan ketentuan berikut mengatur penggunaan Website PT
                  Visi Ekosistem Digital dengan alamat{" "}
                  <a
                    href="https://vionixasia.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cyan-600 underline"
                  >
                    vionixasia.com
                  </a>
                </p>

                <p>
                  Dengan mengakses website ini, Anda dianggap telah menyetujui
                  syarat dan ketentuan ini. Mohon untuk tidak melanjutkan
                  penggunaan website VionixAsia apabila Anda tidak
                  menyetujui salah satu atau seluruh syarat dan ketentuan yang
                  tercantum di halaman ini.
                </p>

                <h3 className="text-xl font-semibold text-cyan-700">Cookie</h3>
                <p>
                  Website ini menggunakan cookie untuk meningkatkan pengalaman
                  pengguna. Dengan mengakses website kami, Anda menyetujui
                  penggunaan cookie yang diperlukan.
                </p>
                <p>
                  Cookie adalah file teks kecil yang disimpan di perangkat Anda
                  oleh server website. Cookie ini tidak dapat digunakan untuk
                  menjalankan program atau mengirimkan virus. Cookie kami
                  digunakan untuk kebutuhan fungsionalitas, analitik, dan
                  pemasaran.
                </p>
                <p>
                  Terdapat beberapa cookie yang wajib diaktifkan demi
                  pengoperasian website. Dengan menyetujui cookie wajib, Anda
                  juga menyetujui cookie pihak ketiga yang mungkin digunakan
                  melalui layanan terintegrasi di website ini, seperti tampilan
                  video, formulir, atau layanan pembayaran.
                </p>

                <h3 className="text-xl font-semibold text-cyan-700">
                  Hak Kekayaan Intelektual
                </h3>
                <p>
                  Kecuali dinyatakan lain, seluruh hak kekayaan intelektual atas
                  konten di website ini dimiliki oleh PT Visi Ekosistem Digital
                  dan/atau pemberi lisensinya. Semua hak dilindungi oleh
                  undang-undang.
                </p>
                <p>
                  Anda diperbolehkan mengakses konten di website ini untuk
                  keperluan pribadi, dengan ketentuan sebagai berikut:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>
                    Dilarang menyalin atau mempublikasikan ulang materi dari
                    website ini.
                  </li>
                  <li>
                    Dilarang menjual, menyewakan, atau mensublisensikan materi
                    dari website ini.
                  </li>
                  <li>
                    Dilarang menggandakan, menyalin, atau memproduksi ulang
                    materi dari website ini.
                  </li>
                  <li>
                    Dilarang mendistribusikan ulang konten dari website ini.
                  </li>
                </ul>

                <h3 className="text-xl font-semibold text-cyan-700">
                  Komentar Pengguna
                </h3>
                <p>
                  Beberapa bagian website memungkinkan pengguna untuk memposting
                  komentar atau informasi. PT Visi Ekosistem Digital tidak
                  bertanggung jawab atas konten komentar yang diposting oleh
                  pengguna.
                </p>
                <p>
                  Dengan memposting komentar di website ini, Anda menyatakan
                  bahwa:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Anda memiliki hak untuk memposting komentar tersebut.</li>
                  <li>
                    Komentar tidak melanggar hak kekayaan intelektual pihak
                    ketiga.
                  </li>
                  <li>
                    Komentar tidak mengandung materi yang melanggar hukum,
                    mencemarkan nama baik, menyinggung, atau melanggar privasi.
                  </li>
                  <li>
                    Komentar tidak digunakan untuk tujuan promosi bisnis atau
                    kegiatan ilegal.
                  </li>
                </ul>
                <p>
                  Anda memberikan lisensi non-eksklusif kepada PT Visi Ekosistem
                  Digital untuk menggunakan, mereproduksi, dan mengedit
                  komentar Anda dalam bentuk, format, atau media apa pun.
                </p>

                <h3 className="text-xl font-semibold text-cyan-700">
                  Tautan ke Website Kami
                </h3>
                <p>
                  Organisasi berikut diperbolehkan membuat tautan ke website
                  kami tanpa izin tertulis:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Lembaga pemerintah</li>
                  <li>Mesin pencari</li>
                  <li>Kantor berita</li>
                  <li>Distributor direktori online yang tercantum</li>
                  <li>Bisnis terakreditasi</li>
                </ul>
                <p>
                  Tautan harus sesuai konteks, tidak menyesatkan, dan tidak
                  menyiratkan hubungan sponsor atau persetujuan dari pihak kami.
                  Kami juga dapat mempertimbangkan permintaan penautan dari
                  organisasi lain yang relevan.
                </p>
                <p>
                  Jika Anda ingin menautkan ke website kami, kirimkan permintaan
                  ke PT Visi Ekosistem Digital beserta informasi organisasi
                  Anda dan tujuan penautan. Kami akan meninjau permintaan
                  tersebut dalam waktu 2-3 minggu.
                </p>
                <p>
                  Tidak diperkenankan menggunakan logo PT Visi Ekosistem Digital
                  atau elemen visual lainnya tanpa izin resmi.
                </p>

                <h3 className="text-xl font-semibold text-cyan-700">
                  Tanggung Jawab atas Konten
                </h3>
                <p>
                  Kami tidak bertanggung jawab atas konten yang muncul di
                  website pihak ketiga yang menautkan ke website kami. Anda
                  setuju untuk melindungi kami dari segala klaim yang timbul
                  akibat konten di website Anda.
                </p>

                <h3 className="text-xl font-semibold text-cyan-700">
                  Penghapusan Tautan
                </h3>
                <p>
                  Kami berhak meminta penghapusan tautan ke website kami kapan
                  saja. Anda setuju untuk segera menghapus tautan tersebut jika
                  diminta.
                </p>

                <h3 className="text-xl font-semibold text-cyan-700">
                  Akurasi Informasi
                </h3>
                <p>
                  Kami tidak menjamin keakuratan, kelengkapan, atau ketersediaan
                  informasi di website ini. Informasi yang tersedia dapat
                  berubah tanpa pemberitahuan.
                </p>

                <h3 className="text-xl font-semibold text-cyan-700">
                  Penolakan Tanggung Jawab
                </h3>
                <p>
                  Selama website ini disediakan secara gratis, kami tidak
                  bertanggung jawab atas kerugian atau kerusakan apa pun yang
                  timbul dari penggunaan website ini, sejauh diizinkan oleh
                  hukum yang berlaku.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
